// This is used for collections and search pages.

import { cacheDom } from '../utils/QuerySelectors.js'
import { setupPaginations } from '../components/Pagination.js'
import { initWishlist, privatePrices } from '../utils/helpers.js'
import { GTM_plpViewItems } from '../utils/Gtm.js'

const dom = {}
const qs = {
  section: 'data-products-grid-wrapper',
  filterBtn: 'data-filter-btn',
  plpPaginator: 'data-plp-paginator',
  plpPaginationNav: 'data-pagination-nav',
  count: 'data-plp-count',
  productsGrid: 'data-products-grid',
  // filterPanel: 'data-filter-panel',
  // sortPanel: 'data-sort-panel',
  clearAll: 'data-fs-clear-all',
  fsPanel: 'data-fs-panel',
  fsPanelInner: 'data-fs-panel-inner',
  fsPanelWrapper: 'data-fs-panel-wrapper',
  fsPanelClose: 'data-fs-panel-close',
  filterSelectsWrapper: 'data-filter-selects-wrapper',
  fsFooter: 'data-fs-footer',
  clearBtn: 'data-clear-btn',
  applyFilters: 'data-apply-filters',
}

const qsAll = {
  facets: 'data-facet',
  sortOptions: 'data-sort-option',
  selectedFilters: 'data-filter-selected',
  videos: 'data-plp-video',
}

const state = {
  facets: [],
  clearAll: null,
  sortOptions: [],
  selectedFilters: [],
}

const initSwipers = () => {
  const swipers = document.querySelectorAll('[data-product-card-swiper]:not(.swiper-initialized)')
  swipers.forEach((slider) => {
    new Swiper(slider, {
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
    })
  })
}

const fetchResults = (url) => {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      dom.plpPaginator.innerHTML = html.querySelector(`[${qs.plpPaginator}]`).innerHTML
      if(dom.plpPaginationNav) dom.plpPaginationNav.innerHTML = (html.querySelector(`[${qs.plpPaginationNav}]`)) ? html.querySelector(`[${qs.plpPaginationNav}]`).innerHTML : ''

      dom.fsPanelWrapper.innerHTML = html.querySelector(`[${qs.fsPanelWrapper}]`).innerHTML
      if (dom.count) dom.count.innerHTML = html.querySelector(`[${qs.count}]`).innerHTML
      dom.filterSelectsWrapper.innerHTML = html.querySelector(`[${qs.filterSelectsWrapper}]`).innerHTML
      state.facets = Array.from(document.querySelectorAll(`[${qsAll.facets}]`))
      state.sortOptions = Array.from(document.querySelectorAll(`[${qsAll.sortOptions}]`))
      state.selectedFilters = Array.from(document.querySelectorAll(`[${qsAll.selectedFilters}]`))

      window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
      window.setupApiTiles(dom.plpPaginator)

      initFacets()
      initWishlist()
      privatePrices()
      setupPaginations()
      document.dispatchEvent(new Event('PLPFilteredResultsLoaded'))
    })
}

const renderFilterResults = (e) => {
  // Current dom filter states
  const currentFacets = Array.from(document.querySelectorAll(`[${qsAll.facets}]`));
  const hasCheckedFacets = currentFacets.some(facet => facet.checked);
  if(e && e.currentTarget && e.currentTarget.hasAttribute('data-sort-option')) {
     const selectedSortOption = Array.from(document.querySelectorAll(`[${qsAll.sortOptions}]`)).find((option) => option.checked)
     if(selectedSortOption) {
        Shopify.analytics.publish('gtm_sort_preference',{ sort: selectedSortOption.value });
     }
  }

  const footer = document.querySelector(`[${qs.fsFooter}]`);
  const clearBtn = document.querySelector(`[${qs.clearBtn}]`);

  if (footer) {
    const hasUrlFilters = window.location.search.includes('filter.') || window.location.search.includes('sort_by'); 
    if (hasCheckedFacets || hasUrlFilters) {
      footer.classList.remove('hidden');
      if (clearBtn) {
        hasCheckedFacets ? clearBtn.classList.remove('hidden') : clearBtn.classList.add('hidden');
      }
    } else {
      footer.classList.add('hidden');
    }
  }
}

const handleFilterInput = (e) => {
  const target = e.target;
  
  if (target.hasAttribute('data-facet')) {
    renderFilterResults(e);
  }
  
  if (target.hasAttribute('data-sort-option')) {
    renderFilterResults(e);
    const prevUrl = getCurrentFilterUrl();
    const filterUrl = `${prevUrl}${prevUrl.includes('?') ? '&' : '?'}section_id=${dom.productsGrid.dataset.sectionId}`;
    history.pushState({}, '', prevUrl);
    fetchResults(filterUrl);
    toggleFilterPanel(false);
  }
}

const handleSelectedFilterClick = (e) => {
  const target = e.target.closest('[data-filter-selected]')
  if (target) {
    const prevUrl = target.dataset.url
    const filterUrl = `${prevUrl}${ !!prevUrl && prevUrl.includes('?') ? '' : '?' }&section_id=${dom.productsGrid.dataset.sectionId}`
    history.pushState({}, '', prevUrl)
    fetchResults(filterUrl)
  }
}

const initFacets = () => {
  // Event delegation on fsPanel
  dom.fsPanel.removeEventListener('change', handleFilterInput)
  dom.fsPanel.addEventListener('change', handleFilterInput)

  dom.filterSelectsWrapper.removeEventListener('click', handleSelectedFilterClick)
  dom.filterSelectsWrapper.addEventListener('click', handleSelectedFilterClick)

  initSwipers()
}

const toggleFilterPanel = (toggle=true) => {
  const focusableElements = Array.from(dom.fsPanel.querySelectorAll('a, button, input'))
  if(toggle) {
    dom.fsPanel.classList.remove('-z-1', 'opacity-0')
    dom.fsPanel.classList.add('z-full', 'opacity-100', 'opened')
    focusableElements.forEach(element => element.removeAttribute('tabindex'))
    setTimeout(() => dom.fsPanelClose.focus(), 50)
  } else {
    dom.fsPanel.classList.add('-z-1', 'opacity-0')
    dom.fsPanel.classList.remove('z-full', 'opacity-100', 'opened')
    focusableElements.forEach(element => element.setAttribute('tabindex', '-1'))
    setTimeout(() => dom.filterBtn.focus(), 50)
  }
}

const getCurrentFilterUrl = () => {
  const currentFacets = Array.from(document.querySelectorAll(`[${qsAll.facets}]`));
  const currentSortOptions = Array.from(document.querySelectorAll(`[${qsAll.sortOptions}]`));

  const selectedFacets = currentFacets
    .filter((facet) => facet.checked)
    .map((facet) => `${facet.name}=${encodeURIComponent(facet.value)}`)
    .join('&');

  const sortBy = currentSortOptions.find(option => option.checked)?.value || '';
  const sortParam = sortBy ? `&sort_by=${sortBy}` : '';

  const baseUrl = dom.productsGrid.dataset.productsGrid.split('?')[0];
  const separator = baseUrl.includes('?') ? '&' : '?';

  return `${baseUrl}${separator}${selectedFacets}${sortParam}`.replace('?&', '?').replace('&&', '&');
}

export const setupCollection = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    privatePrices()
    // Init state with current facets and sort options
    state.facets = Array.from(document.querySelectorAll(`[${qsAll.facets}]`))
    state.sortOptions = Array.from(document.querySelectorAll(`[${qsAll.sortOptions}]`))

    dom.fsPanel.addEventListener('click', (e) => {
      if(e.target === dom.fsPanel) toggleFilterPanel(false)
    })
    dom.fsPanel.querySelector('.popup-content')?.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    dom.filterBtn.addEventListener('click', () => toggleFilterPanel(true))
    dom.fsPanelClose.addEventListener('click', () => toggleFilterPanel(false))

    window.addEventListener('keyup', (e) => {
      if(e.key === "Escape") toggleFilterPanel(false)
    })

    // Apply Filters button listener
    const applyBtn = document.querySelector(`[${qs.applyFilters}]`);
    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        const prevUrl = getCurrentFilterUrl();
        const filterUrl = `${prevUrl}${prevUrl.includes('?') ? '&' : '?'}section_id=${dom.productsGrid.dataset.sectionId}`;
        history.pushState({}, '', prevUrl);
        fetchResults(filterUrl);
        toggleFilterPanel(false);
      });
    }

    // Clear all button listener
    const clearAllBtn = document.querySelector(`[${qs.clearAll}]`);
    if (clearAllBtn) {
       clearAllBtn.addEventListener('click', () => {
          const baseUrl = dom.productsGrid.dataset.productsGrid.split('?')[0];
          history.pushState({}, '', baseUrl);
          fetchResults(`${baseUrl}?section_id=${dom.productsGrid.dataset.sectionId}`);
          toggleFilterPanel(false);
       });
    }

    initFacets()
    initWishlist()
  }

  GTM_plpViewItems(document.querySelectorAll('#product-grid [data-gtm-items-el]:not(.gtm-item_viewed)'));
}